/**
 * Outlined warning triangle used for upload failures on the mobile upload page.
 *
 * Approximates the design's `IPM/icon/warning-large`, which we do not have the asset for — hence
 * the outline and #ce0b24 rather than the solid caution glyph the desktop modal uses. Replace
 * this with the real asset when it is available.
 */
function WarningTriangle(props) {
  return (
    <svg
      aria-hidden='true'
      viewBox='0 0 50 50'
      width='50'
      height='50'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M25 5.5 47.5 44a1.5 1.5 0 0 1-1.3 2.2H3.8A1.5 1.5 0 0 1 2.5 44L25 5.5z'
        fill='none'
        stroke='#ce0b24'
        strokeWidth='3.25'
        strokeLinejoin='round'
      />
      <path d='M25 19v11' fill='none' stroke='#ce0b24' strokeWidth='3' strokeLinecap='round' />
      <circle cx='25' cy='37' r='2.4' fill='#ce0b24' />
    </svg>
  )
}

export default WarningTriangle
